import { registerPlugin } from "@capacitor/core";

const PLATFORM = process.env.REACT_APP_PLATFORM || "web";
const MicrophonePermissions = registerPlugin("MicrophonePermissions");

export const AUDIO_FORMATS = [
  { mimeType: "audio/webm;codecs=opus", extension: "webm" },
  { mimeType: "audio/webm", extension: "webm" },
  { mimeType: "audio/ogg;codecs=opus", extension: "ogg" },
  { mimeType: "audio/mp4", extension: "m4a" },
];

export function selectAudioFormat() {
  if (typeof MediaRecorder === "undefined") return null;
  const supported = AUDIO_FORMATS.find(format => (
    typeof MediaRecorder.isTypeSupported !== "function"
      || MediaRecorder.isTypeSupported(format.mimeType)
  ));
  return supported || { mimeType: "", extension: "webm" };
}

export function extensionForMimeType(mimeType, fallback = "webm") {
  const normalized = String(mimeType || "").toLowerCase();
  if (normalized.includes("ogg")) return "ogg";
  if (normalized.includes("mp4") || normalized.includes("m4a")) return "m4a";
  if (normalized.includes("webm")) return "webm";
  return fallback;
}

export async function requestNativeMicrophonePermission() {
  if (PLATFORM !== "android") return { state: "prompt" };
  return MicrophonePermissions.request();
}

export async function openMicrophoneSettings() {
  if (PLATFORM === "android") return MicrophonePermissions.openSettings();
}

export function microphoneErrorMessage(error) {
  const name = error?.name || "";
  if (name === "NotAllowedError" || name === "SecurityError") return "L’accès au microphone a été refusé.";
  if (name === "NotFoundError" || name === "DevicesNotFoundError") return "Aucun microphone n’a été détecté.";
  if (name === "NotReadableError" || name === "TrackStartError") return "Le microphone est déjà utilisé par une autre application.";
  if (name === "NotSupportedError") return "L’enregistrement audio n’est pas pris en charge sur cet appareil.";
  if (name === "AbortError") return "L’accès au microphone a été interrompu.";
  return "Une erreur navigateur empêche l’accès au microphone.";
}

export const isAndroidPlatform = PLATFORM === "android";
